import { render } from "./LoaderSpinner.vue?vue&type=template&id=7c7459eb&scoped=true"
const script = {}

import "./LoaderSpinner.vue?vue&type=style&index=0&id=7c7459eb&scoped=true&lang=css"

import exportComponent from "/Users/vincent/Documents/GIT_CLONES/skipiste/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c7459eb"]])

export default __exports__